import React from 'react'
import {
  DNAModal,
  DNABox,
  useDisableSwipe,
  DNAButton,
} from '@alucio/lux-ui'
import { DNAModalVariant } from 'src/components/DNA/Modal/DNAConnectedModal'
import styles, { tabletPreviewModalStyles } from './TabletPreviewModalStyles';

interface TabletPreviewModalProps {
  url: string
}

const TabletPreviewModal: DNAModalVariant<TabletPreviewModalProps> = ({
  toggleModal,
  url,
}) => {
  useDisableSwipe()

  return (
    <DNAModal style={styles.container} childFill>
      <DNABox fill appearance="col" style={styles.body}>
        <DNABox alignX="end">
          <DNAButton
            testID="content-present-mode-exit-button"
            appearance="ghost"
            status="tertiary"
            iconLeft="x"
            onPress={toggleModal}
          />
        </DNABox>
        <DNABox fill style={styles.iframeContainer}>
          <iframe
            title="MicrositeViewer"
            src={url}
            style={tabletPreviewModalStyles.iframe}
          />
        </DNABox>
      </DNABox>
    </DNAModal>
  )
}

export default TabletPreviewModal
